import React from 'react'
import NewCommonServiceContent from '../../../common/NewCommonServices/NewCommonServiceContent'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import smm1 from "../../../../assets/images/serviceImages/smm1.webp"
import smm2 from "../../../../assets/images/serviceImages/smm2.webp"
import smm3 from "../../../../assets/images/serviceImages/smm3.webp"
import smm4 from "../../../../assets/images/serviceImages/smm4.webp"
import smm5 from "../../../../assets/images/serviceImages/smm5.webp"
import smm6 from "../../../../assets/images/serviceImages/smm6.webp"

const SocialMediaMarketingWork = () => {
  return (
    <div>
      <NewCommonServiceContent>
        <div>
        <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  className="flex justify-center items-center"
                  pagination={{
                    type: "bullets",
                    el: ".pagination-progress",
                    clickable: true,
                  }}
                  autoplay={true}
                  spaceBetween={20}
                  slidesPerView={1}
                  navigation={{
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                  }}
                  loop
                >
                  <SwiperSlide className="rounded-[16px]">
                    <>
                      <div className="hidden lg:grid lg:grid-cols-3 gap-10">
                        <img
                          src={smm1}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                        <img
                          src={smm2}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                        <img
                          src={smm3}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                        <img
                          src={smm6}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                        <img
                          src={smm4}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                        <img
                          src={smm5}
                          className="rounded-[30px] w-full"
                          alt=""
                        />
                      </div>
                      <div className="lg:hidden">
                        <Swiper
                          modules={[Navigation, Pagination, Autoplay]}
                          className="flex justify-center items-center"
                          pagination={{
                            type: "bullets",
                            el: ".pagination-progress",
                            clickable: true,
                          }}
                          autoplay={true}
                          spaceBetween={20}
                          slidesPerView={1}
                          navigation={{
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                          }}
                          loop
                        >
                          <SwiperSlide>
                            <img
                              src={smm1}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={smm2}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={smm3}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={smm4}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={smm5}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={smm6}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                        </Swiper>
                        <div className="swiper-pagination pagination-progress w-full relative z-10"></div>
                      </div>
                    </>
                  </SwiperSlide>
                </Swiper>
        </div>
      </NewCommonServiceContent>
    </div>
  )
}

export default SocialMediaMarketingWork